import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

/*
 Max width handler for column-based buttons that have icons and set as jumbo etc
 */
export default function maxWidthJumboIconStyle({
  $jumbo,
  $isColumn,
  $hasActiveTick,
  $primary,
  $outline,
  $stretch,
  $hasIcon,
}: ButtonStyleProps) {
  if ($stretch && $outline && $primary && $hasActiveTick && $isColumn && $jumbo && $hasIcon) {
    return css`
      max-width: 11.4rem;
    `;
  }
}
